import { LogbookApproach } from './logbook-approach.model';
import { AutomatedLogbookData } from './automated-logbook-data.model';

export class Logbook {
  logbookId: number = 0; // PK
  actualInstrumentDurationMinutes?: number;
  dayDurationMinutes?: number;
  dayLandings?: number;
  dayTakeoffs?: number;
  nightDurationMinutes?: number;
  nightLandings?: number;
  nightTakeoffs?: number;

  automatedData: AutomatedLogbookData | null;

  // simulatedInstrumentDuration?: number;
  // simulatorDuration?: number;
  // flags
  isHoldPerformed: boolean = false;
  isTrackPerformed: boolean = false;
  // FKs
  flightCrewMemberId: number = 0;
  // collections
  logbookApproaches: LogbookApproach[] = [];

  pilotFlightTimeMinutes?: number;
  pilotNonFlightTimeMinutes?: number;
  totalFlightTime?: number;
  isTotalFlightTimePilotFlightTime: boolean = false;
}
